import { Component, Input } from '@angular/core';
import { ClientsService } from '@cl/core/services/clients.service';
import { Client } from '@cl/shared/models';

@Component({
    selector: 'cl-client-name',
    standalone: false,
    templateUrl: './client-name.component.html',
    styleUrl: './client-name.component.less',
})
export class ClientNameComponent {
    @Input() client: Client;

    constructor(private clientsService: ClientsService) {}

    clientToString(client: Client): string {
        return this.clientsService.toString(client);
    }
}
